export default [
  {
    question: `What do I need to know?`,
    answer: `Staking via Unagii delegates to the Stakewithus validator to help secure the network and receive a share of incentivized rewards earned. Rewards are earned by staking tokens and are paid out at the start of every epoch.`,
  },
  {
    question: `What is the inflation?`,
    answer: `Returns for staked tokens is based on the current inflation rate, total number of SOL staked on the network, and an individual validator's uptime and commission. The initial inflation rate is 8% annually, decreasing by 15% year-over-year, reaching a long-term fixed inflation rate of 1.5% annually.`,
  },
  {
    question: `Is there a lock-up period?`,
    answer: `There is a transition state period when tokens are un-delegated or unstaked. Such tokens will only be able to be withdrawn at the beginning of a new epoch (an epoch is approximately 2 days long). Users will not earn rewards and will be susceptible to slashing during the deactivating cool down period.`,
  },
  {
    question: `How to restake?`,
    answer: `Rewards are auto-compounded by Solana into the same address. However, manual restaking will be required to add additional stake - users will first need unstake, then restake with the additional stake amount.`,
  },
  {
    question: `Is there a fee?`,
    answer: `There is a delegation commission fee paid to Stakewithus for staking.`,
  },
  {
    question: `What are the risks?`,
    answer: `Staking risks do apply including slashing involved for downtime and double signing.`,
  },
];
